import React from 'react'
import githubIcon from '../images/github.png'
import youtubeIcon from '../images/youtube.png'
import SocialIcon from './SocialIcon.js'

export default class ProjectCard extends React.Component {
    constructor(props) {
        super(props)
        this.tags = [
            props.node.category,
            props.node.platform,
            props.node.language,
            props.node.occassion, 
        ].filter(x => x)

        this.state = {
            hover: '',
        }
        this.badgeRef = React.createRef()
        this.githubRef = React.createRef()
        this.youtubeRef = React.createRef()
    }

    mouseOver(e) {
        console.log(this.badgeRef)
    }

    mouseLeave() {
    }

    render() {
        const project = this.props.node
        return <div className="projectCard" onMouseOver={ this.mouseOver.bind(this) } onMouseLeave={ this.mouseLeave.bind(this) }>
            { project.badge ? 
                <a href={ project.badge_link } className="projectBadge" target="_blank" ref={ this.badgeRef }>
                    { project.badge }
                </a> : 
                null 
            }
            <h3>
                { project.name }
            </h3>
            <div className="projectYear">{ project.year }</div>
            <div className="projectDesc"> { project.description } </div>
            <div className="projectTags"> { 
                this.tags.map((tag, i) => <div key={ project.id + "-" + i } className="projectTag">{ tag }</div>) 
            } </div>
            <div className="projectLinks">
                { project.video ? 
                    <a href={ project.video } target="_blank" ref={ this.youtubeRef }> 
                        <SocialIcon src={ youtubeIcon } alt="Youtube" /> 
                    </a> : 
                    null
                }
                { project.link ? 
                    <a style={{ marginLeft: 'auto' }} href={ project.link } target="_blank" ref={ this.githubRef }>  
                        <SocialIcon src={ githubIcon } alt="Github" /> 
                    </a> : 
                    null
                }
            </div>
        </div>
    }
}
